import {
  Row,
  Col,
  Flex,
  theme,
  Dropdown,
  Space,
  Switch,
  Typography,
  Grid,
} from "antd";
import type { MenuProps } from "antd";
import { Header } from "antd/es/layout/layout";
import { useAppContext } from "../context/app/context";
import { UserOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { LANGUAGES, LOCAL_STORAGE_KEYS } from "../common/constants";
import { useThemeContext } from "../context/theme/context";
import { setLanguage, setTheme } from "../context/theme/action";
import { useNavigate } from "react-router-dom";
import { useLogoutMutation } from "../graphql/generated/hooks";
import { MenuOutlined } from "@ant-design/icons";

const { Link } = Typography;
const { useBreakpoint } = Grid;

export function RobinHeader() {
  const { lg } = useBreakpoint();
  const { state } = useAppContext();
  const themeContext = useThemeContext();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const toggleTheme = () => {
    themeContext.dispatch(
      setTheme(themeContext.state.mode === "light" ? "dark" : "light")
    );
  };

  const [logout] = useLogoutMutation();

  const languageToggle = (
    <Link
      onClick={() =>
        themeContext.dispatch(
          setLanguage(
            themeContext.state.language === LANGUAGES.EN
              ? LANGUAGES.AR
              : LANGUAGES.EN
          )
        )
      }
    >
      {themeContext.state.language === LANGUAGES.EN ? "العربية" : "English"}
    </Link>
  );

  const themeToggle = (
    <Switch
      checked={themeContext.state.mode === "dark"}
      onChange={toggleTheme}
      checkedChildren={t("theme.dark")}
      unCheckedChildren={t("theme.light")}
    />
  );

  const items: MenuProps["items"] = [
    ...(!lg
      ? [
          {
            label: state.user?.username,
            disabled: true,
            key: "0",
          },
        ]
      : []),
    {
      label: (
        <Link
          onClick={() => {
            navigate("/profile");
          }}
        >
          {t("button.profile")}
        </Link>
      ),
      key: "1",
    },
    ...(!lg
      ? [
          {
            label: languageToggle,
            key: "2",
          },
          {
            label: themeToggle,
            key: "3",
          },
        ]
      : []),
    {
      type: "divider",
      key: "4",
    },
    {
      style: { color: "red" },
      label: t("button.logout"),
      key: "5",
      onClick: () => {
        logout();
        localStorage.removeItem(LOCAL_STORAGE_KEYS.SESSION_TOKEN);
        window.location.reload();
      },
    },
  ];

  const largeActions = (
    <Space size="large">
      {themeToggle}
      {languageToggle}
      <Dropdown menu={{ items }}>
        <Link onClick={(e) => e.preventDefault()}>
          <Space>
            {state.user?.username}
            <UserOutlined />
          </Space>
        </Link>
      </Dropdown>
    </Space>
  );

  const smallActions = (
    <Dropdown menu={{ items }} trigger={["click"]}>
      <a onClick={(e) => e.preventDefault()}>
        <Space>
          <MenuOutlined />
        </Space>
      </a>
    </Dropdown>
  );

  return (
    <Header
      style={{
        background: colorBgContainer,
      }}
    >
      <Row>
        <Col lg={12} sm={20} xs={20}>
          <Typography.Title ellipsis level={3}>
            {t("title.admin_portal")}
          </Typography.Title>
        </Col>
        <Col lg={12} sm={4} xs={4}>
          <Flex justify="end" align="center">
            {lg ? largeActions : smallActions}
          </Flex>
        </Col>
      </Row>
    </Header>
  );
}
